module.exports = __webpack_public_path__ + "img/power-icon.16a51d12.svg";